import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAuth } from "../context/AuthProvider";
import logoutIcon from "../assets/images/logout.svg";
import logo from "../assets/logo.png";
import collapse from "../assets/images/collapse.svg";
import dashboard from "../assets/images/dashboard.svg";

// Iconițele pentru elementele specifice terapeutului:
import appointmentsIcon from "../assets/images/calendar.svg";
import medalIcon from "../assets/images/medal.svg";
import listIcon from "../assets/images/list.svg";

interface TherapistSidebarProps {
  onCollapseChange?: (collapsed: boolean) => void;
}

const TherapistSidebar: React.FC<TherapistSidebarProps> = ({ onCollapseChange }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Inițializăm starea collapsed din localStorage (folosind o cheie separată pentru terapeut)
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    return localStorage.getItem("sidebarCollapsedTherapist") === "true";
  });

  // Toggle pentru collapse: actualizează starea internă și notifică componenta părinte
  const handleToggle = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    localStorage.setItem("sidebarCollapsedTherapist", newState.toString());
    if (onCollapseChange) {
      onCollapseChange(newState);
    }
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Sigur dorești să ieși din cont?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Da",
      cancelButtonText: "Anulează",
      confirmButtonColor: "#6C298B",
      cancelButtonColor: "#dc3545",
    }).then((result) => {
      if (result.isConfirmed) {
        logout(); // aceasta funcție ar trebui să șteargă token-ul și userul
        navigate("/login");
      }
    });
  };

  return (
    <div className={`therapist-sidebar ${isCollapsed ? "collapsed" : ""}`}>
      {/* Header: logo + buton collapse */}
      <div className="sidebar-header">
        {!isCollapsed && (
          <img src={logo} alt="Logo" className="sidebar-logo" />
        )}
        <button className="collapse-btn" onClick={handleToggle}>
          <img src={collapse} alt="collapse" className="icon-collapse" />
        </button>
      </div>

      <ul className="sidebar-menu">
        {/* Dashboard */}
        <li className={location.pathname === "/therapist/dashboard" ? "ts-item active" : ""}>
          <Link to="/therapist/dashboard">
            <img src={dashboard} alt="dashboard" />
            {!isCollapsed && <span className="text">Dashboard</span>}
          </Link>
        </li>


        {/* Titlu secțiune */}
        {!isCollapsed && <li className="menu-title">Meniu</li>}

        {/* Programări */}
        <li className={location.pathname.startsWith("/therapist/appointments") ? "ts-item active" : ""}>
          <Link to="/therapist/appointments">
            <img src={appointmentsIcon} alt="Programări" />
            {!isCollapsed && <span className="text">Programări</span>}
          </Link>
        </li>

        {/* Statistici */}
        <li className={location.pathname.startsWith("/therapist/scores") ? "ts-item active" : ""}>
          <Link to="/therapist/scores">
            <img src={medalIcon} alt="Punctaje" />
            {!isCollapsed && <span className="text">Punctaje</span>}
          </Link>
        </li>
        <li className={location.pathname.startsWith("/therapist/standings") ? "ts-item active" : ""}>
          <Link to="/therapist/standings">
            <img src={listIcon} alt="Clasamente" />
            {!isCollapsed && <span className="text">Clasament</span>}
          </Link>
        </li>
         <li className={location.pathname.startsWith("/therapist/all-appointments") ? "ts-item active" : ""}>
          <Link to="/therapist/all-appointments">
            <img src={appointmentsIcon} alt="Toate programările" />
            {!isCollapsed && <span className="text">Toate programările</span>}
          </Link>
        </li>

      </ul>
      <button className="logout" onClick={handleLogout}>
        <img src={logoutIcon} alt="Logout" />
        {!isCollapsed && <span className="text">Logout</span>}
      </button>
    </div>
  );
};

export default TherapistSidebar;
